<template>
<div class="row clearfix">
  <div v-if="loading">
    <BlockUI :message="blockuimsg"></BlockUI>
  </div>
  <b-modal :id="infoModal.id" size="xl" :title="title" hide-footer>
       <div class="modal-body mb-3">
          <div class="dd">
            <ol class="dd-list pointer">
              <li v-for="(course, indexCourse) of levels" class="dd-item"
                v-bind:data-id="indexCourse" v-bind:key="indexCourse"
                @click="showOrHideItem($event, 'course_units_modal', indexCourse)"
                @mouseout="hoverDelete($event, indexCourse, null, null, 'H')"
                @mousemove="hoverDelete($event, indexCourse, null, null, 'S')">
                    <div :class="'dd-handle'+getCourseClass(course.curso)" v-bind:id="'modal_course_' + indexCourse">
                      <div class="row">
                        <div class="col col-md-9">
                          <h5 class="title-contentbrowser mb-2"><strong>C:</strong> {{ course.name[`TEXTO_${languageGlobal}`] }}</h5>
                          <div :class="course.zeroExercises ? 'zeroExercises': ''" v-html="course.total"></div>
                        </div>
                        <div class="col col-md-3">
                          <button class="btn btn-primary hide float-right px-3" v-if="resourcelevel=='course'"
                            @click="$emit('selectedItem', {'type':'course', 'levelId': course.id})"
                            type="button" title="Seleccionar Curso">
                              Mover aquí
                          </button>
                        </div>
                      </div>
                    </div>

                  <ol class="dd-list pointer" v-if="course.hasChildren && (resourcelevel=='units' || resourcelevel=='section')"
                    v-bind:id="'course_units_modal_' + indexCourse" style="display: none">
                      <li v-for="(unit, indexUnit) of course.nodes" class="dd-item"
                        v-bind:data-id="indexUnit" v-bind:key="indexUnit"
                        @click="showOrHideItem($event, 'unit_sections_modal_'+indexCourse, indexUnit)"
                        @mouseout="hoverDelete($event, indexCourse, indexUnit, null, 'H')"
                        @mousemove="hoverDelete($event, indexCourse, indexUnit, null, 'S')">
                          <div class="dd-handle"
                            v-bind:id="'modal_course_' + indexCourse + '_unit_' + indexUnit">
                              <div class="row">
                                <div class="col col-md-9">
                                  <h5 class="title-contentbrowser mb-2"><strong>U :</strong> {{ unit.name[`TEXTO_${languageGlobal}`] }}</h5>
                                  <div :class="unit.zeroExercises ? 'zeroExercises': ''" v-html="unit.total"></div>
                                </div>
                                <div class="col col-md-3">
                                  <button class="btn btn-primary hide float-right px-3" v-if="resourcelevel=='units'"
                                    @click="$emit('selectedItem', {'type':'unit', 'levelId': unit.id})"
                                    title="Seleccionar Unidad">
                                      Mover aquí
                                  </button>
                                </div>
                              </div>
                            </div>

                        <ol class="dd-list pointer" v-if="unit.hasChildren && resourcelevel=='section'"
                          v-bind:id="'unit_sections_modal_' + indexCourse + '_' + indexUnit"   style="display: none">
                            <li class="dd-item" v-for="(section, indexSection) of unit.nodes"
                              v-bind:data-id="indexSection"
                              v-bind:key="indexSection"
                              @mouseout="hoverDelete($event, indexCourse, indexUnit,
                                indexSection, 'H')"
                              @mousemove="hoverDelete($event, indexCourse, indexUnit,
                                indexSection, 'S')">
                              <div class="dd-handle"
                                v-bind:id="'modal_course_' + indexCourse + '_unit_' +
                                indexUnit + '_section_' + indexSection">
                                <div class="row">
                                  <div class="col col-md-9">
                                  <h5 class="title-contentbrowser mb-2"><strong>A:</strong> {{ section.name[`TEXTO_${languageGlobal}`] }}</h5>
                                  <div :class="section.zeroExercises ? 'zeroExercises': ''" v-html="section.total"></div>
                                  </div>
                                  <div class="col col-md-3">
                                    <button class="btn btn-primary hide float-right px-3" v-if="resourcelevel=='section'"
                                      @click="$emit('selectedItem', {'type':'section', 'levelId': section.id})"
                                      title="Seleccionar Apartado">
                                        Mover aquí
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </li>
                        </ol>
                      </li>
                  </ol>
              </li>
            </ol>
          </div>
        </div>
    </b-modal>
</div>
</template>

<script>
import $ from 'jquery';

export default {
  props: {
    idModal: {
      type: String,
    },
    title: {
      type: String,
      default: 'Mover contenidos',
    },
  },
  data() {
    return {
      submitted: false,
      levels: [],
      resourceId: null, // id unit, sections o taller
      resourcelevel: null, // course, units, sections
      type: null, // units, sections, talleres
      infoModal: {
        id: this.idModal,
      },
    };
  },
  methods: {
    getCourseClass(curso) {
      if (this.checkUserViewerSecondary() && curso < 20) { // 21 And above are for secundaria courses
        return ' disabled';
      }
      return '';
    },
    /**
    * @method showOrHideItem
    * @description Oculta o muestro un item del organigrama
    */
    showOrHideItem(e, key, indexCourse) {
      if (e !== null) {
        e.stopPropagation();
      }
      const id = `#${key}_${indexCourse}`;
      $(id).slideToggle();
    },
    /**
    * @method hoverDelete
    * @description Oculta o muestra el botón delete para cursos, unidades y talleres
    */
    hoverDelete(e, indexCourse, indexUnit, indexSection, type) {
      e.stopPropagation();

      let key;
      if (indexCourse !== null && indexUnit !== null && indexSection !== null) {
        key = `#modal_course_${indexCourse}_unit_${indexUnit}_section_${indexSection}`;
      } else if (indexCourse !== null && indexUnit !== null) {
        key = `#modal_course_${indexCourse}_unit_${indexUnit}`;
      } else {
        key = `#modal_course_${indexCourse}`;
      }

      const element = $(`${key} > .row > .col > button`);
      if (type === 'S') {
        element.show();
      } else {
        element.hide();
      }
    },
    reset() {
      this.levels = [];
    },
  },
};
</script>
